import anime, { TimelineInstance } from 'animejs';
import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { InjectedApiProps, withApi } from 'src/_context/Api';
import { InjectedAppScrollerProps, withAppScroller } from 'src/_context/AppScroller';
import closeIcon from 'src/assets/icons/Close.svg';
import responsive from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { directions, fontSize } from 'src/constants/stylesheet';
import { Language } from 'src/utils/Languages';
export type MenuProps =
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> &
    {
        loading: boolean;
        opened: boolean;
        toggle: (force?: boolean) => void;
    };

const styles = {
    container: {

    },
    background: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0,
        background: 'white',
        pointerEvents: 'none'
    },
    side: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: 'calc(100% - 20px)',
        maxWidth: 500,
        background: 'white',
        transform: 'translate3d(-100%, 0, 0)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    contentSidesPadding: {
        ...stylesheet.PaddingGutter(2, directions.sides)
    },
    contentTopBottomPadding: {
        [responsive.Mobile]: {
            paddingTop: `${43 / fontSize.Mobile}rem`,
            paddingBottom: spacing.Gutter.Mobile
        },
        [responsive.Tablet]: {
            paddingTop: `${41 / fontSize.Mobile}rem`,
            paddingBottom: spacing.Gutter.Mobile
        },
        [responsive.Desktop]: {
            paddingTop: `${86 / fontSize.Desktop}rem`,
            paddingBottom: spacing.Gutter.Desktop
        },
        [responsive.Big]: {
            paddingTop: `${78 / fontSize.Desktop}rem`,
            paddingBottom: spacing.Gutter.Desktop
        }
    },
    opened: {
        '& $side': {
            pointerEvents: 'initial'
        },
        '& $background': {
            pointerEvents: 'initial'
        }
    },
    menuLinkOuter: {
        marginBottom: 6
    },
    menuLink: {
        ...stylesheet.Link(false, 'left'),

    },
    subMenuLink: {
        ...stylesheet.Link(false, 'left', 5),
        ...stylesheet.Caption,
        lineHeight: 1,
        marginBottom: 10,
    },
    menuLinkActive: {
        ...stylesheet.Link(true, 'left'),
    },
    Subtitle_2: {
        ...stylesheet.Subtitle_2,
    },
    closeMenu: {
        flex: 0,
        display: 'flex',
        alignItems: 'center',
        height: spacing.Header.menuHeight,
        ...stylesheet.MarginGutter(.5, directions.bottom)
    },
    closeMenuIcon: {
        height: 13,
        marginRight: 10
    },
    closeMenuLegend: {
        ...stylesheet.Caption,
        lineHeight: 1
    },
    secondaryMenus: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        ...stylesheet.PaddingGutter(2, directions.all)
    }
};

type Props =
    MenuProps &
    InjectedApiProps &
    RouteComponentProps<any> &
    StyledComponentProps<keyof typeof styles> &
    InjectedAppScrollerProps;

type State = {
};
class Menu extends React.Component<Props, State> {
    private timeline: TimelineInstance;
    constructor(props: Props) {
        super(props);
        this._closeMenu = this._closeMenu.bind(this);
        this._menuClick = this._menuClick.bind(this);
        this._openMenu = this._openMenu.bind(this);
        this._keyDown = this._keyDown.bind(this);
        this.state = {
        };
    }
    componentDidMount() {
        window.addEventListener("keydown", this._keyDown);
        const { classes } = this.props;
        this.timeline =
            anime
                .timeline({
                    autoplay: false,
                    direction: 'alternate',
                    loop: true,
                    changeComplete: () => {
                        this.timeline.pause();
                    }
                })
                .add({
                    targets: `.${classes!.side}`,
                    translateX: ['-100%', '0%'],
                    easing: 'linear',
                    duration: 500
                })
                .add({
                    targets: `.${classes!.background}`,
                    opacity: [0, 0.8],
                    easing: 'linear',
                    duration: 350,
                }, '-=300')
                .add({
                    targets: `.${classes!.contentSidesPadding}, .${classes!.secondaryMenus}`,
                    translateX: ['-100%', '0%'],
                    opacity: 1,
                    easing: 'linear',
                    duration: 350,
                    delay: (el: Element, i: number) => i * 200,
                }, '-=200');
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this._keyDown);
    }
    componentDidUpdate(oldprops: Props) {
        const { props: { opened }, timeline } = this;
        if (opened !== oldprops.opened) {
            timeline.play();
            if (opened === timeline.reversed) {
                timeline.reverse();
            }

        }
    }
    render() {
        const {
            children,
            classes,
            opened,
            loading,
            toggle,
            apiCtx,
            apiCtx: { app },
            appScrollerCtx,
            appScrollerCtx: { currentUrl },
            staticContext,
            ...rest
        } = this.props;

        const closeText = Language === 'en' ? 'Close' : 'Fermer';
        
        return (
            <nav
                {...rest}
                className={
                    classNames(
                        classes!.container,
                        rest.className,
                        opened && classes!.opened
                    )
                }
            >
                <div className={classes!.background} onClick={this._closeMenu} />
                <div
                    className={
                        classNames(
                            classes!.side
                        )
                    }
                    onClick={this._menuClick}
                >
                    <div className={classNames(classes!.contentSidesPadding, classes!.contentTopBottomPadding)}>
                        <a onClick={this._closeMenu} className={classes!.closeMenu}>
                            <img src={closeIcon} alt="close icon" className={classes!.closeMenuIcon} />
                            <span className={classes!.closeMenuLegend}>
                                {closeText}
                            </span>
                        </a>
                        <div className={classNames(classes!.menuLinkOuter)}>
                            <Link
                                className={
                                    classNames(
                                        classes!.menuLink,
                                        classes!.Subtitle_2,
                                        currentUrl === `/${Language}/home/intro` && classes!.menuLinkActive
                                    )
                                }
                                onClick={this._closeMenu}
                                to={`/${Language}/home/intro`}
                            >

                                {Language === 'en' ? 'Home' : 'Accueil'}
                            </Link>

                        </div>
                        {app && app.Menus.map((menu, i) =>
                            <div key={menu.Url} className={classNames(classes!.menuLinkOuter)}>
                                <Link
                                    className={
                                        classNames(
                                            classes!.menuLink,
                                            classes!.Subtitle_2,
                                            currentUrl === menu.Url && classes!.menuLinkActive
                                        )
                                    }
                                    onClick={this._closeMenu}
                                    key={menu.UID}
                                    to={`${menu.Url}`}
                                >
                                    {menu.Title}
                                </Link>
                            </div>
                        )}
                        {children}
                    </div>
                    <div className={classNames(classes!.secondaryMenus)}>
                        {app && app.SecondaryMenus.map((s, i) =>
                            <Link
                                key={s.UID}
                                to={`${s.Url}`}
                                className={
                                    classNames(
                                        classes!.subMenuLink,
                                        currentUrl === s.Url && classes!.menuLinkActive
                                    )
                                }
                                onClick={this._closeMenu}
                            >
                                {s.Title}
                            </Link>
                        )}
                    </div>
                </div>
            </nav>);
    }
    private _menuClick(e: React.MouseEvent<HTMLDivElement>) {
        e.preventDefault();
        e.stopPropagation();

    }
    private _closeMenu() {
        const { toggle } = this.props;
        toggle(false);
    }

    private _openMenu() {
        const { toggle } = this.props;
        toggle(true);
    }

    private _keyDown(e: KeyboardEvent) {
        const { opened, toggle } = this.props;
        if (opened && (e.key === "Escape" || e.keyCode === 27)) { // escape key maps to keycode `27`
            e.preventDefault();
            e.stopPropagation();
            toggle(false);
        }
    }

    // private _toSection(id: string) {
    //     const { toggle } = this.props;

    //     return () => {
    //         toggle(false);
    //         // push(id);
    //     };
    // }

}

export default withStyles(styles)(withApi(withAppScroller(withRouter(Menu))));


// WEBPACK FOOTER //
// ./src/components/Menu.tsx